let aboutData = [
	{
		img: "gaurav.webp",
		name: "Gaurav Gupta",
		title: "Technical Head",
		github: "https://github.com/programmergaurav",
		instagram: "https://www.instagram.com/programmergaurav/",
		linkedin: "https://www.linkedin.com/in/programmergaurav/",
	},
	{
		img: "kate.webp",
		name: "Abhishek Kate",
		title: "Designing Head",
		github: "https://github.com/abhishekate2002",
		instagram: "https://www.instagram.com/abhi_rk__/",
		linkedin: "https://www.linkedin.com/in/abhishek-kate-6879bb1b3/",
	},
	{
		img: "jayesh.webp",
		name: "Jayesh Padhale",
		title: "Social Media Head",
		github: "",
		instagram: "https://www.instagram.com/___jsp_/",
		linkedin: "",
	},
	{
		img: "sawant.webp",
		name: "Prathamesh Sawant",
		title: "Marketing Head",
		github: "",
		instagram: "https://www.instagram.com/prathamesh2789/",
		linkedin: "",
	},
	{
		img: "sid.webp",
		name: "Siddhesh Mane",
		title: "Non Tech Head",
		github: "",
		instagram: "https://www.instagram.com/_sid__mane_/",
		linkedin: "",
	},
	{
		img: "manish.webp",
		name: "Manish Mohan",
		title: "Invitation Head",
		github: "",
		instagram: "https://www.instagram.com/manishhhh11/",
		linkedin: "",
	},
	{
		img: "baggu.webp",
		name: "Bhagyavan",
		title: "Event Head",
		github: "",
		instagram: "https://www.instagram.com/bhagyavan_2514/",
		linkedin: "",
	},
	{
		img: "santra.webp",
		name: "Shubhamkar",
		title: "Gaming Head",
		github: "https://github.com/SantraMosambi",
		instagram: "https://www.instagram.com/santra_mosambi/",
		linkedin: "https://www.linkedin.com/in/shubhamkar-bhattacharya-ab5787131/",
	},
];
export default aboutData;
